import React, { FC, ReactNode, useEffect, useState } from 'react'

import { CheckPicker, CheckPickerItemType, OptionsProps } from '@avantstay/backoffice-core'

import { leadSourceFilterOptions } from '@new/__global/constants/filter'

import { FiltersSharedProps } from './Filters.types'

interface LeadSourceFilterProps extends FiltersSharedProps {
  initialValue?: string[]
  onChange: (value?: string[]) => void
  options?: OptionsProps<string>[]
}

export const LeadSourceMainFilter: FC<LeadSourceFilterProps> = ({
  initialValue,
  onChange,
  options,
}) => {
  const [selectedSources, setSelectedSources] = useState<string[] | undefined>(initialValue)

  const handleSearchSources = (
    keyword: string,
    _label: ReactNode,
    item: CheckPickerItemType,
  ): boolean => {
    if (keyword && keyword.length > 0) {
      const labelString = item.label && item.label.toString()
      const keywordString = keyword.trim().replace(/[^a-zA-Z0-9]/g, '')
      const pattern = new RegExp(`\\b${keywordString}`, 'gi')

      return Boolean(labelString && labelString.match(pattern))
    }

    return true
  }

  const handeOnClearOptions = () => {
    setSelectedSources(undefined)
    onChange(undefined)
  }

  const handleOnCloseOptions = () => {
    if (selectedSources !== initialValue) {
      onChange(selectedSources)
    }
  }

  const handleOnSelectOptions = (value: string[]) => {
    setSelectedSources(value)
  }

  useEffect(() => {
    // We can have a second filter and we need to update both filters onChange
    if (initialValue !== selectedSources) {
      setSelectedSources(initialValue)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initialValue])

  return (
    <CheckPicker.Small
      searchable
      options={options ?? leadSourceFilterOptions}
      placeholder="Any channel"
      value={selectedSources || []}
      onClean={handeOnClearOptions}
      onClose={handleOnCloseOptions}
      searchBy={handleSearchSources}
      onSelect={handleOnSelectOptions}
    />
  )
}
